export const GetPaginationPage = () => {
  return parseInt(
    document.location.href
      .split('/page/')
      .pop()
      .slice(0, 2)
      .replace('/', ''),
    10
  )
}
